import app from 'flarum/forum/app';
import isValidUrl from './isValidUrl';
import extractUriHost from './extractUriHost';
export const PROVIDERS = {
  google: host => "https://www.google.com/s2/favicons?domain=".concat(host),
  duckduckgo: host => "https://icons.duckduckgo.com/ip3/".concat(host, ".ico"),
  yandex: host => "https://favicon.yandex.net/favicon/".concat(host)
};
export default function getFaviconUrl(url) {
  const faviconProvider = app.forum.attribute('fof-socialprofile.favicon_provider');
  if (!isValidUrl(url) || !faviconProvider || !(faviconProvider in PROVIDERS)) return null;
  const host = extractUriHost(url);
  if (!host) return null;
  return PROVIDERS[faviconProvider](host);
}
flarum.reg.add('fof-socialprofile', 'forum/helpers/getFaviconUrl', getFaviconUrl);